import { Link, useLocation } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  AiFillHome,
  AiOutlineInfoCircle
} from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { HiOutlineSparkles } from "react-icons/hi";
import { MdOutlineGames } from "react-icons/md";

const dropdownAnim = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0 }
};

export default function FloatingBottomNavbar() {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);

  const navRef = useRef(null);

  const isHome = location.pathname === "/";

  const activeClass = "scale-110 text-[#8B5A2B]";

  // ✅ OUTSIDE CLICK CLOSE
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <motion.div
      initial={{ y: 80 }}
      animate={{ y: 0 }}
      className="fixed bottom-3 left-0 right-0 flex justify-center z-50 md:hidden"
    >
      <div
        ref={navRef}
        className="flex items-center gap-8 px-6 py-3 rounded-3xl shadow-xl backdrop-blur-md"
        style={{ background: "rgba(255,255,255,0.95)" }}
      >

        {/* HOME */}
        <Link to="/">
          <div className={`navIcon ${isHome ? activeClass : ""}`}>
            <AiFillHome size={30}/>
          </div>
        </Link>

        {/* TESTS */}
        <div className="relative">
          <div
            onClick={() => setOpenMenu(openMenu==="tests"?null:"tests")}
            className="navIcon"
          >
            <FiEdit size={30}/>
          </div>

          <AnimatePresence>
            {openMenu==="tests" && (
              <motion.div
                variants={dropdownAnim}
                initial="hidden"
                animate="visible"
                exit="hidden"
                className="absolute bottom-14 left-[-60px] bg-white rounded-xl shadow-lg w-44 p-2"
              >
                {/*<Link to="/test" className="dropItem">Public Tests</Link>*/}
                <Link to="/createtest" className="dropItem">Create Test</Link>
                <Link to="/mytests" className="dropItem">My Tests</Link>
                <Link to="/tests/practice" className="dropItem">Practice</Link>
                <Link to="/tests/timed" className="dropItem">Timed</Link>
                <Link to="/tests/exam" className="dropItem">Exam</Link>
                <Link to="/tests/adaptive" className="dropItem">Adaptive</Link>
                <Link to="/groups" className="dropItem">Playlists</Link>

              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* AI TOOLS */}
        <div className="relative">
          <div
            onClick={() => setOpenMenu(openMenu==="ai"?null:"ai")}
            className="navIcon"
          >
            <HiOutlineSparkles size={30}/>
          </div>

          <AnimatePresence>
            {openMenu==="ai" && (
              <motion.div
                variants={dropdownAnim}
                initial="hidden"
                animate="visible"
                exit="hidden"
                className="absolute bottom-14 left-[-60px] bg-white rounded-xl shadow-lg w-44 p-2"
              >
                <Link to="/question-extraction" className="dropItem">
                  Question Extraction
                </Link>
                <Link to="/flashcards" className="dropItem">
                  Flashcards
                </Link>
                <Link to="/support" className="dropItem">
  ❤️ Supportus
</Link>

              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* GAME */}
        {/* GAME */}
<div className="relative">
  <div
    onClick={() => setOpenMenu(openMenu==="games" ? null : "games")}
    className="navIcon"
  >
    <MdOutlineGames size={28}/>
  </div>

  <AnimatePresence>
    {openMenu==="games" && (
      <motion.div
        variants={dropdownAnim}
        initial="hidden"
        animate="visible"
        exit="hidden"
        className="absolute bottom-14 left-[-70px] bg-white rounded-xl shadow-lg w-52 p-2"
      >
        <Link to="/game" className="dropItem">🎮 Test Game</Link>

        <Link to="/observation-game" className="dropItem">
          👀 Observation Game
        </Link>

        <Link to="/focus-game" className="dropItem">
          🎯 Focus Game
        </Link>

        <Link to="/focus-game-v2" className="dropItem">
          🚀 Focus Game WR
        </Link>

        <Link to="/memory-game" className="dropItem">
          🧠 Memory Game
        </Link>

        <Link to="/memory-game-v2" className="dropItem">
          🚀 Memory WR
        </Link>

        <Link to="/car-game" className="dropItem">
          🚗 Car Game
        </Link>

        <Link to="/airstrike" className="dropItem">
          ✈️ Air Strike
        </Link>
      </motion.div>
    )}
  </AnimatePresence>
</div>

        {/* ABOUT */}
        <Link to="/about">
          <div className="navIcon">
            <AiOutlineInfoCircle size={30}/>
          </div>
        </Link>

      </div>
    </motion.div>
  );
}
